import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from 'signup-constants/Step';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { getLandingPageButton } from './getLandingPageText';
import { useLandingPage } from './useLandingPage';
import Honeypots from '../honeypots/CustomInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EmbeddedHaveAnAccount = styled.div.withConfig({
  displayName: "LandingPageView__EmbeddedHaveAnAccount",
  componentId: "sc-176kln1-0"
})(["", ""], props => props.theme.embedded && `
      margin-top: 1.5rem;
      font-size: 14px;
      margin-bottom: 1.5rem;
    `);
const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService,
    shouldShowSignInButton
  } = getFlowConfig();
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  useExperiment(ExperimentKeys.COAC0002, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0154, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0156, TrackWhen.enrolled);
  const Footer = () => {
    return isInstanceOfSignupEmbedder ? /*#__PURE__*/_jsxs(EmbeddedHaveAnAccount, {
      className: "text-center",
      children: [shouldShowSignInButton && /*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: Step.LandingPage,
    children: [/*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [/*#__PURE__*/_jsx(LandingPageTitle, {
          isMobile: isMobile
        }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
          $layoutType: layoutType,
          $shouldRestrictWidth: true,
          children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), /*#__PURE__*/_jsx(SignupDataInputForm, {
            autoFocus: false,
            buttonProps: {
              label: getLandingPageButton()
            },
            dataKey: Data.Email,
            inputMode: 'email',
            shouldTrimData: true,
            submit: chooseEmailSignUp
          }, Data.Email), /*#__PURE__*/_jsx(Footer, {})]
        })]
      })
    }), /*#__PURE__*/_jsx(Honeypots, {})]
  });
};
export default LandingPageView;